import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export function getCookie(name) {
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));

  if (parts.length === 2) {
    var cookieData = parts.pop().split(';').shift();
    return decodeURIComponent(cookieData);
  }

  return false;
}
export default (function (userInfo) {
  var ANALYTICS_DATA_OBJECT = window.digitalData;

  if (userInfo) {
    var loginStatus = // eslint-disable-next-line no-nested-ternary
    userInfo.userState === 'GUEST' ? 'Non-Registered' : userInfo.userState === 'RECOGNISED' ? 'Recognised' : 'Registered';
    ANALYTICS_DATA_OBJECT.user[0].profile = [_objectSpread(_objectSpread({}, window.digitalData.user[0].profile), {}, {
      profileInfo: {
        profileID: userInfo.userId
      },
      attributes: {
        loginStatus: loginStatus
      }
    })];
    ANALYTICS_DATA_OBJECT.page.pageInfo.attributes = {
      globalView: document.cookie.indexOf('PostCodeSessionCookie') < 0 || getCookie('PostCodeSessionCookie') === '%2C%2C'
    };
  }
});
export function getPageHeadAnalytics() {
  var initialDataObject = {
    page: {
      pageInfo: {},
      attributes: {}
    }
  };
  initialDataObject.page.pageInfo.pageName = 'ar:storeselector';
  initialDataObject.page.pageInfo.siteSection = 'ar:storeselector';
  initialDataObject.page.attributes.platform = 'react';
  var script = "var getCookie = ".concat(getCookie.toString(), ";var is_from_mcomm = document.referrer.indexOf('argos.co.uk/m/') > -1");
  var setChannelValue = "getCookie('analytics_channel') === 'mcomm' || is_from_mcomm ? 'uk:mobile' : 'uk:desktop'";
  return "".concat(script, ";window.digitalData = ").concat(JSON.stringify(initialDataObject), ";digitalData.page.attributes.channel = ").concat(setChannelValue);
}
export function doTrack(pageName, eventName, attributes) {
  var waitForSDigitalDataAndTrack = function waitForSDigitalDataAndTrack() {
    if (window.digitalData === undefined || window.digitalData === null || !window.digitalData.track) {
      setTimeout(function () {
        waitForSDigitalDataAndTrack();
      }, 500);
    } else {
      try {
        window.digitalData.page.pageInfo.pageName = pageName;
        window.digitalData.page.attributes = attributes;
        window.digitalData.track(eventName);
      } catch (error) {
        console.warn('Error with digitalData object:', error);
      }
    }
  };

  waitForSDigitalDataAndTrack();
}
export function doTrackClick(eventName, event) {
  var waitForSDigitalDataAndTrack = function waitForSDigitalDataAndTrack() {
    if (window.digitalData === undefined || window.digitalData === null || !window.digitalData.track) {
      // console.log(`Trying to fire '${eventName}'`)
      setTimeout(function () {
        waitForSDigitalDataAndTrack();
      }, 500);
    } else {
      try {
        // console.log(`Firing _satellite.track for event '${eventName}'`)
        if (!window.digitalData.event) window.digitalData.event = [];
        window.digitalData.event.push(event);
        window.digitalData.track(eventName);
      } catch (error) {
        console.warn('Error with digitalData object:', error);
      }
    }
  };

  waitForSDigitalDataAndTrack();
}